import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, skipWhile, take } from 'rxjs';

import { TermsAndConditionsFacade } from 'src/app/modules/ngrx-store/terms-and-conditions/terms-and-conditions.facade';

export const termsAndConditionsGuard: CanActivateFn = () => {
	const termsAndConditionsFacade = inject(TermsAndConditionsFacade);

	return termsAndConditionsFacade.loadTermsAndConditionsPending$.pipe(
		skipWhile(pending => pending !== false), // Wait until loading has explicitly finished
		take(1),
		map(() => true)
	);
};
